// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ActionPlanSummaryWidget_planSummary__IdtPS {
  padding: 14px;
  border: 1px solid #dce3e8;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(30, 55, 75, 0.06);
}

.ActionPlanSummaryWidget_planSummary__IdtPS h2 {
  margin: 0 0 14px;
  padding-bottom: 10px;
  border-bottom: 1px solid #697782;
  font-size: 1rem;
}

.ActionPlanSummaryWidget_planSummary__IdtPS > p {
  min-height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  color: #687681;
  font-size: 0.86rem;
  text-align: center;
}

.ActionPlanSummaryWidget_planSummary__IdtPS > button {
  width: 100%;
  margin-top: 12px;
  padding: 8px 10px;
  border: 1px solid #d3dce3;
  border-radius: 7px;
  background: #fff;
  color: #455f78;
  cursor: pointer;
}

.ActionPlanSummaryWidget_planItem__Tb6ws {
  --action-color: var(--upcare-value-bienveillance);
  --action-soft: var(--upcare-value-bienveillance-soft);

  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px;
  border: 1px solid #e2e7eb;
  border-left: 4px solid var(--action-color);
  border-radius: 8px;
  background: #fbfcfd;
  cursor: pointer;
  transition: border-color 120ms ease, box-shadow 120ms ease, transform 120ms ease;
}

.ActionPlanSummaryWidget_bienveillance__\\+lZ1L {
  --action-color: var(--upcare-value-bienveillance);
  --action-soft: var(--upcare-value-bienveillance-soft);
}

.ActionPlanSummaryWidget_engagement__zGQaB {
  --action-color: var(--upcare-value-engagement);
  --action-soft: var(--upcare-value-engagement-soft);
}

.ActionPlanSummaryWidget_faireEquipe__1WNp2 {
  --action-color: var(--upcare-value-faire-equipe);
  --action-soft: var(--upcare-value-faire-equipe-soft);
}

.ActionPlanSummaryWidget_respect__zHFiJ {
  --action-color: var(--upcare-value-respect);
  --action-soft: var(--upcare-value-respect-soft);
}

.ActionPlanSummaryWidget_planItem__Tb6ws:hover,
.ActionPlanSummaryWidget_planItem__Tb6ws:focus-visible {
  border-color: #c8d6df;
  border-left-color: var(--action-color);
  box-shadow: 0 4px 12px rgba(30, 55, 75, 0.09);
  outline: none;
}

.ActionPlanSummaryWidget_planItem__Tb6ws:active {
  transform: translateY(1px);
}

.ActionPlanSummaryWidget_typeBadge__0XNkV {
  align-self: flex-start;
  padding: 3px 7px;
  border: 1px solid var(--action-color);
  border-radius: 999px;
  background: var(--action-soft);
  color: #263746;
  font-size: 0.72rem;
}

.ActionPlanSummaryWidget_planItem__Tb6ws strong {
  font-size: 0.84rem;
}

.ActionPlanSummaryWidget_planItem__Tb6ws small {
  color: #697782;
}

.ActionPlanSummaryWidget_trainingMeta__DJUSe {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 4px;
  padding-top: 8px;
  border-top: 1px solid #e7ecef;
}

.ActionPlanSummaryWidget_capacity__OfomG {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #526773;
  font-size: 0.76rem;
  white-space: nowrap;
}

.ActionPlanSummaryWidget_capacity__OfomG > span:first-child {
  color: var(--action-color);
}

.ActionPlanSummaryWidget_registrationButton__yeP61 {
  border: 1px solid var(--action-color);
  border-radius: 999px;
  padding: 4px 9px;
  background: var(--action-color);
  color: #fff;
  font-size: 0.72rem;
  font-weight: 700;
  cursor: pointer;
}

.ActionPlanSummaryWidget_registrationButton__yeP61:hover {
  filter: brightness(0.92);
}

.ActionPlanSummaryWidget_registeredBadge__BGftE,
.ActionPlanSummaryWidget_fullBadge__T4tlf {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 3px 9px;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 700;
}

.ActionPlanSummaryWidget_registeredBadge__BGftE {
  border: 1px solid var(--action-color);
  background: var(--action-soft);
  color: #263746;
}

.ActionPlanSummaryWidget_fullBadge__T4tlf {
  background: #edf0f2;
  color: #61717b;
}

.ActionPlanSummaryWidget_error__wTRNk {
  color: #b42318 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/ActionPlan/ActionPlanSummaryWidget.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iDAAiD;EACjD,qDAAqD;;EAErD,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,yBAAyB;EACzB,0CAA0C;EAC1C,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gFAAgF;AAClF;;AAEA;EACE,iDAAiD;EACjD,qDAAqD;AACvD;;AAEA;EACE,8CAA8C;EAC9C,kDAAkD;AACpD;;AAEA;EACE,gDAAgD;EAChD,oDAAoD;AACtD;;AAEA;EACE,2CAA2C;EAC3C,+CAA+C;AACjD;;AAEA;;EAEE,qBAAqB;EACrB,sCAAsC;EACtC,6CAA6C;EAC7C,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,qCAAqC;EACrC,oBAAoB;EACpB,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;EACpB,gBAAgB;EAChB,+BAA+B;EAC/B,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".planSummary {\n  padding: 14px;\n  border: 1px solid #dce3e8;\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: 0 2px 8px rgba(30, 55, 75, 0.06);\n}\n\n.planSummary h2 {\n  margin: 0 0 14px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #697782;\n  font-size: 1rem;\n}\n\n.planSummary > p {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  color: #687681;\n  font-size: 0.86rem;\n  text-align: center;\n}\n\n.planSummary > button {\n  width: 100%;\n  margin-top: 12px;\n  padding: 8px 10px;\n  border: 1px solid #d3dce3;\n  border-radius: 7px;\n  background: #fff;\n  color: #455f78;\n  cursor: pointer;\n}\n\n.planItem {\n  --action-color: var(--upcare-value-bienveillance);\n  --action-soft: var(--upcare-value-bienveillance-soft);\n\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 10px;\n  border: 1px solid #e2e7eb;\n  border-left: 4px solid var(--action-color);\n  border-radius: 8px;\n  background: #fbfcfd;\n  cursor: pointer;\n  transition: border-color 120ms ease, box-shadow 120ms ease, transform 120ms ease;\n}\n\n.bienveillance {\n  --action-color: var(--upcare-value-bienveillance);\n  --action-soft: var(--upcare-value-bienveillance-soft);\n}\n\n.engagement {\n  --action-color: var(--upcare-value-engagement);\n  --action-soft: var(--upcare-value-engagement-soft);\n}\n\n.faireEquipe {\n  --action-color: var(--upcare-value-faire-equipe);\n  --action-soft: var(--upcare-value-faire-equipe-soft);\n}\n\n.respect {\n  --action-color: var(--upcare-value-respect);\n  --action-soft: var(--upcare-value-respect-soft);\n}\n\n.planItem:hover,\n.planItem:focus-visible {\n  border-color: #c8d6df;\n  border-left-color: var(--action-color);\n  box-shadow: 0 4px 12px rgba(30, 55, 75, 0.09);\n  outline: none;\n}\n\n.planItem:active {\n  transform: translateY(1px);\n}\n\n.typeBadge {\n  align-self: flex-start;\n  padding: 3px 7px;\n  border: 1px solid var(--action-color);\n  border-radius: 999px;\n  background: var(--action-soft);\n  color: #263746;\n  font-size: 0.72rem;\n}\n\n.planItem strong {\n  font-size: 0.84rem;\n}\n\n.planItem small {\n  color: #697782;\n}\n\n.trainingMeta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-top: 4px;\n  padding-top: 8px;\n  border-top: 1px solid #e7ecef;\n}\n\n.capacity {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  color: #526773;\n  font-size: 0.76rem;\n  white-space: nowrap;\n}\n\n.capacity > span:first-child {\n  color: var(--action-color);\n}\n\n.registrationButton {\n  border: 1px solid var(--action-color);\n  border-radius: 999px;\n  padding: 4px 9px;\n  background: var(--action-color);\n  color: #fff;\n  font-size: 0.72rem;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.registrationButton:hover {\n  filter: brightness(0.92);\n}\n\n.registeredBadge,\n.fullBadge {\n  display: inline-flex;\n  align-items: center;\n  min-height: 26px;\n  padding: 3px 9px;\n  border-radius: 999px;\n  font-size: 0.72rem;\n  font-weight: 700;\n}\n\n.registeredBadge {\n  border: 1px solid var(--action-color);\n  background: var(--action-soft);\n  color: #263746;\n}\n\n.fullBadge {\n  background: #edf0f2;\n  color: #61717b;\n}\n\n.error {\n  color: #b42318 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"planSummary": `ActionPlanSummaryWidget_planSummary__IdtPS`,
	"planItem": `ActionPlanSummaryWidget_planItem__Tb6ws`,
	"bienveillance": `ActionPlanSummaryWidget_bienveillance__+lZ1L`,
	"engagement": `ActionPlanSummaryWidget_engagement__zGQaB`,
	"faireEquipe": `ActionPlanSummaryWidget_faireEquipe__1WNp2`,
	"respect": `ActionPlanSummaryWidget_respect__zHFiJ`,
	"typeBadge": `ActionPlanSummaryWidget_typeBadge__0XNkV`,
	"trainingMeta": `ActionPlanSummaryWidget_trainingMeta__DJUSe`,
	"capacity": `ActionPlanSummaryWidget_capacity__OfomG`,
	"registrationButton": `ActionPlanSummaryWidget_registrationButton__yeP61`,
	"registeredBadge": `ActionPlanSummaryWidget_registeredBadge__BGftE`,
	"fullBadge": `ActionPlanSummaryWidget_fullBadge__T4tlf`,
	"error": `ActionPlanSummaryWidget_error__wTRNk`
};
export default ___CSS_LOADER_EXPORT___;
